/* Adds document navigation without hiding or rewriting policy provisions. */
(() => {
  function enhance(root) {
    if (root.dataset.policyReady) return;
    root.dataset.policyReady = 'true';
    const body = root.querySelector('[data-policy-body]');
    const contents = root.querySelector('[data-policy-contents]');
    const links = root.querySelector('[data-policy-links]');
    if (!body || !contents || !links) return;
    // Empty rich-text spacer paragraphs and headings add no content.
    body.querySelectorAll('p,h2,h3').forEach(node => {
      if (!node.textContent.trim() && !node.querySelector('img,iframe,input')) node.remove();
    });
    if (root.dataset.policyKind === 'terms') body.querySelectorAll('h3,p').forEach(node => {
      if (node.tagName !== 'H3' && node.textContent.trim() !== 'OVERVIEW') return;
      const heading = document.createElement('h2');
      heading.innerHTML = node.innerHTML;
      if (node.id) heading.id = node.id;
      node.replaceWith(heading);
    });
    body.querySelectorAll('h2,h3').forEach((heading, index) => {
      const text = heading.textContent.trim();
      // Existing terms use uppercase labels. Only their casing changes.
      if ((text === text.toUpperCase() || /^SECTION \d+ - /.test(text)) && /[A-Z]/.test(text)) {
        const lower = text.toLowerCase();
        heading.textContent = lower.replace(/(^| - )([a-z])/g, (_, prefix, letter) => prefix + letter.toUpperCase());
      }
      if (!heading.id) heading.id = root.querySelector('h1').id + '-section-' + index;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = heading.textContent;
      li.append(a); links.append(li);
    });
    // Keep store policy references on the public domain.
    body.querySelectorAll('a[href]').forEach(a => {
      const url = new URL(a.href, location.href);
      if (url.hostname === 'presspeelship.myshopify.com' && /^\/pages\/(refund-policy|privacy-policy|terms-of-service)$/.test(url.pathname)) a.href = url.pathname;
    });
    if (links.children.length) {
      contents.hidden = false;
      contents.querySelector('details').open = matchMedia('(min-width:750px)').matches;
    }
  }
  function init(scope = document) { scope.querySelectorAll('[data-policy-page]').forEach(enhance); }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
